<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      width="40%"
      center>
      <div class="agreement">
        <div class="doc">
          <div v-html="getXssIntro(content)"></div>
        </div>
        <!-- <div class="doc" v-if="type === 7">
          <p>为维护商户（“您”）的合法权益，请您仔细阅读、充分理解本活动规则的各项内容，本活动规则是您参与“团油”所推出活动合作业务事宜的确认，自您勾选/点击同意后即视为您确认本活动规则内容，同意按本确活动规则执行。</p>
          <p>1. 鉴于您所运营的加油站已上线团油平台，并与团油平台运营主体【车主邦（北京）科技有限公司或其合作方能链石化科技有限公司】签署了相关合作协议（“合作协议”），由团油平台向加油站引流客户。自您确认本协议后，即视为您同意参加团油平台推出的【天天特价】活动。</p>
          <p>2.【天天特价】活动指团油平台针对商户运营的加油站推出的营销推广活动，即商户通过额外降价的方式参加活动后，平台将赋予商户额外的活动曝光，助力商户吸引用户，增加营收。</p>
          <p>3.【天天特价】具体活动内容、活动形式以团油实际提前向您告知，并经您确认后最终上线的为准。</p>
          <p>4.【天天特价】具体上线时间、活动期间、让利比例等具体细节以团油和您另行根据实际情况确认的为准。</p>
          <p>5. 您同意以油价让利的形式承担因参加【天天特价】所实际发生的费用，即活动期间，团油将根据与您沟通确认的让利比例向加油用户提供加油优惠，并在应向您结算的加油费用中直接扣除该部分费用。</p>
          <p>6. 您同意团油可以通过团油平台公告、站内信、以及合作协议下预留的电话、邮箱等联系方式向您发出各项通知及确认，您应及时回复确认，您未提出异议的视为确认无异议。</p>
          <p>7. 如您欲终止活动的，需提前告知团油；您不得未经团油书面确认擅自更改活动规则，否则因此造成的损失由您自行承担。</p>
          <p>8. 您知悉并确认，团油平台的针对每家参与活动的商户定制不同的营销活动方案，实际上线活动展示可能因油站参与程度而不同。</p>
        </div>
        <div class="doc" v-if="type === 9">
          <p>为维护商户（“您”）的合法权益，请您仔细阅读、充分理解本确认函的各项内容，本确认函是您参与“团油”所推出商户合作业务细节事宜的确认，自您勾选/点击同意后即视为您确认本确认函内容，同意按本确认函约定执行。</p>
          <p>1. 鉴于您所运营的加油站已上线团油平台，并与团油平台运营主体【车主邦（北京）科技有限公司或其合作方能链石化科技有限公司】签署了相关合作协议（“合作协议”），由团油平台向加油站引流客户。自您确认本协议后，即视为您同意参加团油平台推出的【限时秒杀】活动。</p>
          <p>2.【限时秒杀】活动指团油平台针对商户运营的加油站推出的营销推广活动，即商户通过额外降价的方式参加活动后，平台将赋予商户额外的活动曝光，助力商户吸引用户，增加营收。</p>
          <p>3.【限时秒杀】具体活动内容、活动形式以团油实际提前向您告知，并经您确认后最终上线的为准。</p>
          <p>4.【限时秒杀】具体上线时间、活动期间、让利比例等具体细节以团油和您另行根据实际情况确认的为准。</p>
          <p>5. 您同意以油价让利的形式承担因参加【限时秒杀】所实际发生的费用，即活动期间，团油将根据与您沟通确认的让利比例向加油用户提供加油优惠，并在应向您结算的加油费用中直接扣除该部分费用。</p>
          <p>6. 您同意团油可以通过团油平台公告、站内信、以及合作协议下预留的电话、邮箱等联系方式向您发出各项通知及确认，您应及时回复确认，您未提出异议的视为确认无异议。</p>
          <p>7. 如您欲终止活动的，需提前告知团油；您不得未经团油书面确认擅自更改活动规则，否则因此造成的损失由您自行承担。</p>
          <p>8. 您知悉并确认，团油平台的针对每家参与活动的商户定制不同的营销活动方案，实际上线活动展示可能因油站参与程度而不同。</p>
        </div> -->
         <div class="rule">点击报名代表您已知悉并且认同相关规则</div>
        <el-button class="confirm" type="primary" size="mini" @click="handleProcess">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { accept } from '@/api/marketPromotion'
import { getXssIntro } from '@/utils/xss'

export default {
  props: {
    type: {
      type: Number  // 8-送水，7-天天特价，9-限时秒杀
    },
    router: {
      type: String // 跳转路由
    }
  },
  // watch: {
  //   type: {
  //     handler (val) {
  //       if (val === 8) {
  //         this.title = '团油一箱水活动协议'
  //       } else if (val === 7) {
  //         this.title = '天天特价活动协议'
  //       } else {
  //         this.title = '限时秒杀活动协议'
  //       }
  //     },
  //     immediate:true
  //   }
  // },
  data () {
    return {
      centerDialogVisible: false,
      title: '',
      content: ''
    }
  },
  methods: {
    getXssIntro,
    init (title, content) {
      this.title = title
      this.content = `${decodeURIComponent(content)}`
      this.centerDialogVisible = true
    },
    // 流程
    async handleProcess () {
      // 送水的不需要调取协议的接口
      // if (this.type === 8) {
      //   this.$router.push({ path: this.router })
      //   return
      // }
      const { code } = await accept({ activityType: this.type })
      if(code !== 200) return
      this.$router.push({ path: this.router })
    },
  }
}
</script>
<style scoped lang="less">
.agreement{
  display: flex;
  flex-direction: column;
  align-items: center;
  .agree-tip{
    margin: 10px 0;
  }
  .doc{
    height: 400px;
    overflow-y: auto;
    padding: 10px 20px 20px 20px;
    text-indent: 28px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
  }
  .rule{
    margin: 18px 0;
    color: #666666;
    text-align: center;
  }
  .confirm {
    width: 100px;
    height: 40px;
    background: #4B7EFE;
    border-radius: 4px;
  }
}
/deep/.el-dialog__title{
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
}
</style>
